/******************************************************************************************
 *	Customer Service
 ********************************************************************************************/
(function() {


  angular
    .module('rcServices.customer', [])
    .service(
      'Customer',
      /* @ngInject */
      function(_, $q, customerResponseTransformer, DemoMode, jilResellerCustomers, MiniJil, User) {
        //Get customer details
        this.getDetails = function(customerId) {
          return jilResellerCustomers.customerDetails.get({
            customerId,
            resellerId: User.getResellerID()
          }).$promise;
        };

        //Get all customer data, including details, products, purchases, renewals and products available to the customer
        this.get = function(customerId) {
          if (DemoMode.isEnabled()) {
            const data = MiniJil.getCustomer(customerId);
            if (data) {
              return $q.resolve(customerResponseTransformer(data));
            } else {
              return $q.reject({
                data: {},
                status: 404
              });
            }
          } else {
            return jilResellerCustomers.customers
              .get({
                customerId,
                resellerId: User.getResellerID()
              })
              .$promise.then(responseData => customerResponseTransformer(responseData));
          }
        };

        this.getCustomersOrderHistory = function(customerId) {
          return jilResellerCustomers.customersOrderHistory
            .get({
              customerId,
              resellerId: User.getResellerID()
            })
            .$promise;
        };

        this.getCustomersPASalesAQO = function(customerId, saleAqoIds) {
          return jilResellerCustomers.customersPASalesAQO
            .get({
              customerId,
              resellerId: User.getResellerID(),
              saqoIds: saleAqoIds,
            })
            .$promise;
        };
        this.getCustomerOrganizationDetails = function (customerId){
          return jilResellerCustomers.customerOrganizationDetails
          .get({
            customerId
          })
          .$promise;
        };

        //Update customer
        this.update = function(customerId, payload) {
          if (DemoMode.isEnabled()) {
            const data = MiniJil.updateCustomer(customerId, payload);
            if (data) {
              return $q.resolve(data);
            } else {
              return $q.reject({
                data: {},
                status: 400
              });
            }
          } else {
            return jilResellerCustomers.customers.update(
              {
                customerId,
                resellerId: User.getResellerID()
              },
              payload
            ).$promise;
          }
        };

        //Update sales representative
        this.updateSalesRep = function(customerId, newSalesRepId) {
          var payload = {
            managedBy: {
              userId: newSalesRepId
            }
          };

          return this.update(customerId, payload);
        };

        //Move customer to new reseller org
        this.migrateToNewReseller = function(customerId, newResellerId) {
          var payload = {
            resellerId: newResellerId
          };

          return this.update(customerId, payload);
        };

        //Extend customer renewal window
        this.extendRenewalWindow = function(customerId, extensionData) {
          var payload = {
            renewalWindowInfo: extensionData
          };

          return this.update(customerId, payload);
        };
      }
    )
    .factory(
      'customerResponseTransformer',
      /* @ngInject */
      function (_, DefaultResponseTransformer, feature, PRODUCT_CHANNELS, RcProduct, defaultProductsSorter) {
        var transformer = function (responseData, headers) {
          let data = DefaultResponseTransformer.processData(responseData, headers);

          //Save reference to the most common product sorter function so that it's not created each time,
          //especially inside loops.
          //"Most common" because most JIL data is structured as product.code and product.name.
          var productSorter = defaultProductsSorter('product.code', 'product.name');

          //Plain Object to Entity conversions
          if (data) {
            var orgId = _.get(data, 'details.id');
            var contractId = _.get(data, 'details.vipnumber');
            //Convert products (data.products) to proper entity
            if (_.get(data, 'products.productList.length')) {
              data.products.productList = _.map(data.products.productList, function(item) {
                if (item.productInfo) {
                  item.product = new RcProduct(item.productInfo, orgId, contractId);
                  delete item.productInfo;
                }
                return item;
              });

              //Sort
              data.products.productList.sort(productSorter);
            }

            // Convert enterprise products (data.enterpriseProducts) to proper entity.
            if (_.get(data, 'EVIPProducts.productList.length')) {
              data.EVIPProducts.productList = _.map(data.EVIPProducts.productList, function(item) {
                if (item.productInfo) {
                  item.product = new RcProduct(item.productInfo, orgId, contractId);
                  delete item.productInfo;
                }
                return item;
              });

              //Sort
              data.EVIPProducts.productList.sort(productSorter);
            }

            //Convert products (data.purchases) to proper entity
            if (_.get(data, 'purchases.length')) {
              _.forEach(data.purchases, function (purchase) {
                if (_.get(purchase, 'purchaseItems.length')) {
                  purchase.purchaseItems = transformProductInfosToProducts({
                    contractId,
                    items: purchase.purchaseItems,
                    orgId
                  });

                  // Because we may have removed a purchase item above, we need to sum the remaining purchase
                  // items so the seat count will be right.
                  purchase.seatCount = _.sumBy(
                    purchase.purchaseItems,
                    'quantity'
                  );

                  //Sort
                  purchase.purchaseItems.sort(productSorter);
                }
              });
            }

            //Convert products (data.renewals) to proper entity
            if (_.get(data, 'renewals.length')) {
              _.forEach(data.renewals, function (order) {
                if (_.get(order, 'renewalItems.length')) {
                  order.renewalItems = transformProductInfosToProducts({
                    contractId,
                    items: order.renewalItems,
                    orgId
                  });

                  // Because we may have removed an order item above, we need to sum the remaining order
                  // items so the seat count will be right.
                  order.seatCount = _.sumBy(order.renewalItems, 'quantity');

                  //Sort
                  order.renewalItems.sort(productSorter);
                }
              });
            }
          }

          return data;
        };

        /**
         * @description Helper to check whether a provided productInfo instance has channels that
         *  indicate it should be displayd or whether it should be filtered out (which should be the case for Phone Auth and KBA).
         *
         * @param {Array<String>} customerUI - Array of channels to be checked against
         * @returns {Boolean} True if the provided array has at least one valid channel contained in PRODUCT_CHANNELS
         */
        function hasValidChannels(customerUI) {
          return _.some(customerUI, ui => _.includes(PRODUCT_CHANNELS, ui));
        }

        /**
         * @description Helper to take an array of purchase or renewal items and transform their productInfo into RC Product instances.
         *   Note: Any product info that does not possess channels required to be displayed in RC will be dropped.
         *
         * @param {Object} options - Wrapper object for the arguments to this function.
         * @param {String} options.contractId - Id of the contract that the product belongs to.
         * @param {Array<PurchaseItem|RenewalItem>} options.items - Array of raw objects that are either PurchaseItems or RenewalItems,
         * each item will have its productInfo transformed in the resulting response if the item itself is not filtered out.
         * @param {String} options.orgId - Id of the organization this product belongs to.
         *
         * @returns {Array<PurchaseItem|RenewalItem>} - Array of purchase items or renewal items with their product info transformed.
         */
        function transformProductInfosToProducts(options) {
          const {contractId, items, orgId} = options;

          return _(items)
            .map(item => {
              if (item.productInfo) {
                if (!_.has(item, 'productInfo.customerUI') || hasValidChannels(item.productInfo.customerUI)) {
                  // For items that don't have the customerUI property at all we will construct the
                  // RcProduct like normal because we don't want to erroneously filter them out.
                  // Added in response to VIP#: 42BEFC091C9918D86BEA from
                  // ticket: https://jira.corp.adobe.com/browse/CAUIP-6058
                  item.product = new RcProduct(
                    item.productInfo,
                    orgId,
                    contractId
                  );
                  delete item.productInfo;
                } else {
                  return undefined;
                }
              }

              return item;
            })
            .compact()
            .value();
        }

        return transformer;
      }
    );
})();
